<template>
    <!-- Hero Sections Here -->
   <section class="banner__breadcumn ralt">

<!--Search Popup-->
<div id="searchPopup" class="search__popup">
   <form action="#" class="popup-content d-flex align-items-center">
      <input type="text" placeholder="Search Here">
      <button id="closeButton">
         <i class="bi bi-x-lg"></i>
      </button>
   </form>
</div>
<!--Search Popup-->

<div class="breadcumnd__wrapper">
   <div class="container">
      <div class="profile__wrapper">
         <div class="row g-4 align-items-center justify-content-between">
            <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
               <div class="breadcumnd__content">
                  <span class="d41 mb-24">
                     Marka haqida
                  </span>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</section>
<!-- Hero Section End -->

<!--service grid here-->
<section class="service__grid pt-120 pb-120 sectionbg2">
<div class="container">
   <div class="row g-4">
      <div class="col-xl-4 col-lg-4">
         <div class="card__sidebar side__sticky round16" style="background: #0141a2;">
            <div class="card__common__item bgwhite round16">
               <span class="cateicon">
                  <img src="assets/img/markalar/marka (1).jpg" alt="round" style="width: 100%; height: 100%;">
               </span>
            </div>
         </div>
      </div>
      <div class="col-xl-8 col-lg-8">
         <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="Barcha_tariflar" role="tabpanel"
               aria-labelledby="barcha_tariflar-tab">
               <div class="overview__gitwrapper bgwhite round16 border">
                  <p class="fz-32 pb-40 bborderdash mb-20 title2">
                     Respublika ichidagi xizmatlar
                  </p>
                  <div class="accordion-body" style="color: black;">
                     <p class="title2">Сhiqarilgan sana: 2022 yil</p>
                     <p class="title2">Addadi:10000</p>
                     <p class="title2">Nominal: 12 700 so‘m</p>
                  </div>
                  <div class="divider">
                     <span>MARKA HAQIDA MA'LUMOT</span>
                  </div>
                  <p>Seriya 4 ta pochta markasidan iborat. Pochta markalarida viloyatning turli ustalari –
                     lyaganlarning mahsulotlari tasvirlangan, mahsulot mualliflari ko‘rsatilgan. Pochta markalari
                     rang-barang. Ofset bosib chiqarish. Pochta markalarining taroqsimon teshilishi. Pochta
                     markalarining o‘lchami 42x30 mm.</p>
               </div>

            </div>


         </div>
      </div>
   </div>
</div>
</section>
<!--service grid end-->
</template>